export default __webpack_public_path__ + "static/media/blog-pill-bg.11a9c640.png";